import { css } from '@linaria/core';

const cssVariable = {
  stroke: `--tui-loader-stroke`,
  size: `--tui-loader-size`,
};

const loader = css`
  ${cssVariable.stroke}: 10px;
  ${cssVariable.size}: 100%;
  fill: none;
  stroke: currentColor;
`;

const spinner = css`
  --radius: calc((var(${cssVariable.size}) - var(${cssVariable.stroke})) / 2);
  --deg: calc(3.14159 / 180 * var(--radius));

  stroke-width: var(${cssVariable.stroke});
  r: var(--radius);
  transform-origin: 50% 50%;

  stroke-dasharray: calc(180 * var(--deg)), calc(360 * var(--deg));
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, rotate 2s linear infinite;
  stroke-linecap: square;

  @keyframes dash {
    0% {
      stroke-dasharray: calc(3 * var(--deg)), calc(582 * var(--deg));
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: calc(260 * var(--deg)), calc(582 * var(--deg));
      stroke-dashoffset: calc(-100 * var(--deg));
    }

    100% {
      stroke-dasharray: calc(260 * var(--deg)), calc(582 * var(--deg));
      stroke-dashoffset: calc(-360 * var(--deg));
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;

const styles = {
  loader,
  spinner,
};

export default styles;
